module.exports = __webpack_public_path__ + "static/media/free.9fffe65c.png";